import { render, staticRenderFns } from "./MinMessage.vue?vue&type=template&id=d481f076&scoped=true&"
import script from "./MinMessage.vue?vue&type=script&lang=js&"
export * from "./MinMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d481f076",
  null
  
)

export default component.exports